import { render } from "./MainBanner.vue?vue&type=template&id=3f92e844"
import script from "./MainBanner.vue?vue&type=script&lang=js"
export * from "./MainBanner.vue?vue&type=script&lang=js"

import exportComponent from "/Users/anderson/Developer/Landing-Page/CambiosItalo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__